import { SharedFunctions } from '../../../../src/app/shared/shared.functions';
import { Component, HostListener, OnInit } from '@angular/core';
import { MatDrawer, MatDrawerMode } from '@angular/material/sidenav';

@Component({
  selector: 'app-default',
  templateUrl: './default.component.html',
  styleUrls: ['./default.component.scss']
})

export class DefaultComponent implements OnInit {

  sideBarOpen:boolean;
  isMobile: boolean;
  modoSidebar: MatDrawerMode;

  constructor(
   private sharedFunctions: SharedFunctions
  ) { }

  ngOnInit(): void {
    this.isMobile = this.sharedFunctions.sizeView();
    this.sideBarsize(null);
    if(this.isMobile)
      this.sideBarOpen = false;
    else
      this.sideBarOpen = true;
  }

  sideBarToggler(e) {
    this.sideBarOpen = !this.sideBarOpen;
  }

  @HostListener('window:resize', ['$event'])

  sideBarsize(event){
    this.isMobile = this.sharedFunctions.sizeView();
    this.modoSidebar = this.isMobile ? 'over' : 'side';
  }
}
